module.exports = __webpack_public_path__ + "static/media/background-4seg-new.5e2be559.png";